const Button = ({ children, variant = "primary", className = "", ...props }) => {
  const baseStyles = "px-4 py-[10px] rounded-full focus:outline-none focus:ring transition";
  
  const variants = {
    primary: "bg-gradient-to-b from-[#3a7293] to-[#2e5b76] text-white hover:bg-[#2e5b76] focus:ring-[#3a7293] text-xs",
    secondary: "bg-gray-50 text-red-600 hover:bg-gray-300 focus:ring-gray-300 text-xs",
    danger: "bg-red-500 text-white hover:bg-red-600 focus:ring-red-300 text-xs",
  };
  
  return (
    <button className={`${baseStyles} ${variants[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
};

export default Button;
